import { NgModule } from '@angular/core';
import { DetailedSizeFilterComponent } from './detailed-size-filter.component';
import { FcpDropdownTreeModule } from 'fc-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { BadgeSizePipe } from './badge-size.pipe';

const pipes = [BadgeSizePipe];
const components = [DetailedSizeFilterComponent];

@NgModule({
    imports: [FcpDropdownTreeModule, TranslateModule, CommonModule],
    declarations: [...components, ...pipes],
    exports: [...components, ...pipes]
})
export class DetailedSizeFilterModule {}
